'use client';
import { useFriendlyViewPort } from '../../../hooks/useFriendlyViewPort';
import { useValRoute } from '../../../val/val.client';
import Body from '../../../components/Body/Body';
import { useEffect, useRef } from 'react';
import SectionHeader2 from '../../../components/Handboka/SectionHeader2';
import ScrollToTopButton from '../../../components/ScrollToTopButton/ScrollToTopButton';
import ChapterHeader from '../../../components/Handboka/ChapterHeader';
import Search from '../../../components/Handboka/Search';
import AboutMobileNav from '../../../components/Handboka/AboutMobileNav';
import Nav from '../../../components/Handboka/Nav';
import PageHeader from '../../../components/PageHeader/PageHeader';
import LargeLayout from '../../../containers/LargeLayout';
import pageVal from './page.val';
import { notFound } from 'next/navigation';

const Handbook = ({ params }: { params: Promise<never> }) => {
  const page = useValRoute(pageVal, params);

  useFriendlyViewPort();

  const chaptersRef = useRef<Array<HTMLDivElement | null>>([]);

  useEffect(() => {
    chaptersRef.current = chaptersRef.current.slice(0, page?.chapters.length);
  }, [page]);

  const setChapterRef = (idx: number, el: HTMLDivElement | null) => {
    chaptersRef.current[idx] = el;
  };
  if (!page) {
    return notFound();
  }
  const { header, subHeader, chapters } = page;
  return (
    <div id="handboka">
      <LargeLayout customGap="gap-0 tablet:gap-128">
        <PageHeader header={header} subheader={subHeader} />
        <div className="w-full grid grid-cols-1 tablet:grid-cols-[240px_1fr__48px] gap-16">
          <Nav chapters={chapters} chaptersRef={chaptersRef} />
          <section className={`w-full flex flex-col items-center`}>
            <div className="flex flex-col gap-64 items-center justify-center relative laptop:max-w-[650px]">
              <AboutMobileNav chapters={chapters} chaptersRef={chaptersRef} />
              <Search />
              <div className="flex flex-col gap-64 px-[20px] laptop:px-[0px] searchable">
                {chapters.map((chapter, idx) => (
                  <div
                    key={idx}
                    id={chapter.slug}
                    ref={(el) => setChapterRef(idx, el)}
                    className="scroll-mt-[170px]"
                  >
                    <div className="mb-32">
                      <ChapterHeader
                        title={
                          idx === 0
                            ? chapter.sections[0].header
                            : chapter.header
                        }
                      />
                    </div>
                    <div className={`space-y-[60px] first:mt-0`}>
                      {chapter.sections.map((section, sectionIdx) => (
                        <div
                          key={sectionIdx}
                          className="flex flex-col h-fit"
                          id={section.slug}
                        >
                          {idx !== 0 && (
                            <SectionHeader2
                              title={section.header}
                              classes="laptop:pt-[0px] text-[22px] font-medium"
                            />
                          )}
                          <Body
                            richText={section.text}
                            className="text-18 tablet:text-[20px] font-light"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
          <ScrollToTopButton />
        </div>
      </LargeLayout>
    </div>
  );
};

export default Handbook;
